import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid'; // Migrated to v7 convention
import { getOrderInfoDetails } from './data/DetailPurchase';
import { getProductDetails } from './data/DetailsHistoryPrepaid';
import { getTransactionDetails } from './data/DetailsNetPay';
import { getBankDetails } from './data/DetailsOpenPay';
import { getPurchaseDetailsAiralo } from './data/DetailsPurchaseAiralo';
import { getContactDetailsOrdersIPB } from './data/DetailsPurchaseOrdersIpb';
import { getContactDetails } from './data/DetailsSimIpb';
import { DetailsSTP } from './data/DetailsSTP';
import { DetailsToku } from './data/DetailsToku';

const InfoRow = ({ label, value }) => (
  <Grid
    item
    size={{ xs: 6 }}
    style={{
      marginTop: '8px',
      wordWrap: 'break-word',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    <Typography variant='body1'>
      <span style={{ fontSize: '0.875rem' }}>{label}:</span> {value || 'N/A'}
    </Typography>
  </Grid>
);

const OrderInfoGrid = ({ orderDetails, type, title }) => {
  const titleStyle = { color: '#7A3C92' };
  let infoItems = [];

  if (type === 'detailsSTP') {
    infoItems = DetailsSTP(orderDetails);
  } else if (type === 'detailsToku') {
    infoItems = DetailsToku(orderDetails);
  } else if (type === 'detailsNetPay') {
    infoItems = getTransactionDetails(orderDetails);
  } else if (type === 'detailsHistoryPrepaid') {
    infoItems = getProductDetails(orderDetails);
  } else if (type === 'detailsSimIpb') {
    infoItems = getContactDetails(orderDetails);
  } else if (type === 'detailPurchase') {
    infoItems = getOrderInfoDetails(orderDetails);
  } else if (type === 'detailsOpenPay') {
    infoItems = getBankDetails(orderDetails);
  } else if (type === 'DetailsPurchaseOrdersIpb') {
    infoItems = getContactDetailsOrdersIPB(orderDetails);
  } else if (type === 'AiraloDetails') {
    infoItems = getPurchaseDetailsAiralo(orderDetails);
  }
  return (
    <Grid container className='device-info' size={{ xs: 12 }} mt={2}>
      {type === 'detailsSTP' && (
        <Grid item size={{ xs: 12 }}>
          <span style={titleStyle}>{title}</span>
        </Grid>
      )}
      {infoItems.map((item, index) => (
        <InfoRow key={index} label={item?.label} value={item?.value} />
      ))}
    </Grid>
  );
};

export default OrderInfoGrid;
